// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

// const TestimonialSection = () => {
//   const [testimonials, setTestimonials] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchTestimonials = async () => {
//       try {
//         const response = await axios.get("https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/testimonials");
//         setTestimonials(response.data.data);
//         setLoading(false);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to fetch testimonials");
//         setLoading(false);
//       }
//     };
//     fetchTestimonials();
//   }, []);

//   if (loading) return <div className="text-center py-5">Loading testimonials...</div>;
//   if (error) return <div className="text-center py-5 text-danger">{error}</div>;
//   if (!testimonials.length) return <div className="text-center py-5">No testimonials available.</div>;

//   // Owl Carousel options
//   const carouselOptions = {
//     items: 3,        // Show 3 testimonials at a time (col-lg-3)
//     margin: 30,
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 3000,
//     autoplayHoverPause: true,
//     dots: false,
//     nav: false,
//     responsive: {
//       0: { items: 1 },
//       576: { items: 1 },
//       768: { items: 2 },
//       992: { items: 3 },
//     },
//   };

//   return (
//     <section className="testimonial-area pb-40 fix" id="testimonials-sec">
//       <div className="container">
//         <div className="row justify-content-center mb-5">
//           <div className="col-xl-7 col-lg-8 text-center">
//             <span className="section-subtitle tp_fade_left">Testimonials</span>
//             <h2 className="section-title tp_title_slideup mb-0">
//                Reviews for Our Satisfied Clients
//             </h2>
//           </div>
//         </div>

//         <OwlCarousel className="owl-theme" {...carouselOptions}>
//           {testimonials.map((t, index) => (
//             <div className="testimonial-block-one shadow-sm p-5 mb-5 bg-white rounded" key={t._id || index}>
//               <div className="inner-box text-center">
//                 <p>{t.quote || "Lorem ipsum dolor sit amet..."}</p>
//                 <div className="author-box mt-3">
//                   <figure className="thumb-box mb-2">
//                     <img
//                       src={t.authorImage || "assets/images/resource/testimonial-2.png"}
//                       alt={t.authorName || "Anonymous"}
//                       style={{
//                         width: "60px",
//                         height: "60px",
//                         objectFit: "cover",
//                         borderRadius: "50%",
//                         margin: "0 auto",
//                       }}
//                     />
//                   </figure>
//                   <h5>{t.authorName || "Anonymous"}</h5>
//                   <span className="designation">{t.authorTitle || "User"}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </OwlCarousel>
//       </div>
//     </section>
//   );
// };

// export default TestimonialSection;







import React, { useState, useEffect } from "react";
import axios from "axios";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get("https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/testimonials");
        setTestimonials(response.data.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch testimonials");
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  if (loading) return (
    <div className="text-center py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-muted">Loading testimonials...</p>
    </div>
  );
  
  if (error) return (
    <div className="text-center py-5">
      <div className="alert alert-danger d-inline-block" role="alert">
        {error}
      </div>
    </div>
  );
  
  if (!testimonials.length) return (
    <div className="text-center py-5">
      <div className="alert alert-info d-inline-block" role="alert">
        No testimonials available.
      </div>
    </div>
  );

  const carouselOptions = {
    items: 3,
    margin: 30,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    dots: true,
    nav: true,
    navText: [
      '<span class="carousel-nav-prev"><i class="bi bi-chevron-left"></i></span>',
      '<span class="carousel-nav-next"><i class="bi bi-chevron-right"></i></span>'
    ],
    responsive: {
      0: { items: 1, nav: false },
      576: { items: 1, nav: false },
      768: { items: 2, nav: true },
      992: { items: 3, nav: true },
    },
  };

  return (
    <section className="testimonial-section py-5 position-relative overflow-hidden" id="testimonials-sec">
      {/* Background decoration */}
      <div className="testimonial-bg-decoration position-absolute top-0 start-0 w-100 h-100"></div>
      
      <div className="container position-relative">
        <div className="row justify-content-center mb-5">
          <div className="col-xl-7 col-lg-8 text-center">
            <span className="section-subtitle d-inline-block px-3 py-1 mb-3 rounded-pill bg-light text-primary fw-semibold">
              Client Testimonials
            </span>
            <h2 className="section-title display-5 fw-bold mb-4">
              What Our Clients Say
            </h2>
            <p className="lead text-muted mx-auto">
              Discover the experiences of our valued clients and partners
            </p>
          </div>
        </div>

        <OwlCarousel className="owl-theme testimonial-carousel" {...carouselOptions}>
          {testimonials.map((t, index) => (
            <div className="testimonial-item h-100" key={t._id || index}>
              <div className="testimonial-card card h-100 border-0 shadow-sm rounded-4 overflow-hidden transition-all">
                <div className="card-body p-4 p-lg-5 d-flex flex-column">
                  <div className="testimonial-rating mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="bi bi-star-fill text-warning"></i>
                    ))}
                  </div>
                  
                  <blockquote className="testimonial-quote flex-grow-1 mb-4">
                    <p className="fs-5 fst-italic text-secondary">
                      "{t.quote || "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam auctor, nisl eget ultricies tincidunt, nisl nisl aliquam nisl, eget ultricies nisl nisl eget nisl."}"
                    </p>
                  </blockquote>
                  
                  <div className="testimonial-author d-flex align-items-center mt-auto">
                    <div className="author-avatar me-3">
                      <img
                        src={t.authorImage || "https://picsum.photos/seed/user123/100/100.jpg"}
                        alt={t.authorName || "Anonymous"}
                        className="img-fluid rounded-circle border border-3 border-white shadow"
                        style={{ width: "60px", height: "60px", objectFit: "cover" }}
                      />
                    </div>
                    <div>
                      <h5 className="author-name mb-0 fw-bold">{t.authorName || "Anonymous"}</h5>
                      <p className="author-position text-muted mb-0">{t.authorTitle || "Client"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
      
      <style jsx>{`
        .testimonial-section {
          background-color: #f8f9fa;
        }
        
        .testimonial-bg-decoration {
          background: radial-gradient(circle at 10% 20%, rgba(100, 130, 255, 0.05) 0%, rgba(100, 130, 255, 0) 50%),
                      radial-gradient(circle at 90% 80%, rgba(255, 100, 130, 0.05) 0%, rgba(255, 100, 130, 0) 50%);
          z-index: 0;
        }
        
        .section-subtitle {
          font-size: 0.9rem;
          letter-spacing: 0.5px;
        }
        
        .section-title {
          position: relative;
          z-index: 1;
        }
        
        .section-title::after {
          content: "";
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, #4361ee, #3a0ca3);
          border-radius: 2px;
        }
        
        .testimonial-carousel .owl-nav {
          position: absolute;
          top: 50%;
          width: 100%;
          transform: translateY(-50%);
          display: flex;
          justify-content: space-between;
          padding: 0 15px;
          pointer-events: none;
        }
        
        .testimonial-carousel .owl-nav button {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: white;
          color: #4361ee;
          border: 1px solid #e9ecef;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: all;
          transition: all 0.3s ease;
        }
        
        .testimonial-carousel .owl-nav button:hover {
          background: #4361ee;
          color: white;
          transform: scale(1.1);
        }
        
        .testimonial-carousel .owl-dots {
          margin-top: 30px;
          text-align: center;
        }
        
        .testimonial-carousel .owl-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #dee2e6;
          margin: 0 5px;
          transition: all 0.3s ease;
        }
        
        .testimonial-carousel .owl-dot.active {
          background: #4361ee;
          transform: scale(1.3);
        }
        
        .testimonial-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .testimonial-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
        }
        
        .testimonial-rating i {
          font-size: 0.9rem;
          margin-right: 2px;
        }
        
        .testimonial-quote p {
          line-height: 1.6;
        }
        
        .author-avatar img {
          transition: transform 0.3s ease;
        }
        
        .testimonial-card:hover .author-avatar img {
          transform: scale(1.05);
        }
        
        @media (max-width: 767.98px) {
          .testimonial-carousel .owl-nav {
            display: none;
          }
        }
      `}</style>
    </section>
  );
};

export default TestimonialSection;